/**
 * Translation dictionary.
 *
 * Keys are referenced from the markup through the data-i18n* attributes
 * handled in ./index.js. Values whose key ends in `Html` may contain markup.
 *
 * Deliberately NOT translated (proper nouns, or would break the layout
 * they live in):
 *  - the hero display type "FULL — STACK DEVELOPER": one <span> per letter at
 *    32.8rem, so a longer word overflows the viewport
 *  - the stack list (HTML5, REACTJS, …) and the client/brand names
 *  - "BUENOS AIRES", "GITHUB", "LINKEDIN"
 */

const GITHUB = "https://github.com/javierpalina";
const FIGMA_TINTS =
  "https://www.figma.com/community/plugin/943569346291474506/Tints-and-Shades";
const FIGMA_LOGOS =
  "https://www.figma.com/community/plugin/949697027067571105/Nigerian-Logos";
const FIGMA_AVATARS =
  "https://www.figma.com/community/plugin/999661511334406897/Bavatars";

const link = (href, label) =>
  `<a href="${href}" target="_blank" rel="noopener noreferrer">${label}</a>`;

export const DEFAULT_LANG = "en";

export const LANGS = [
  { code: "en", label: "EN" },
  { code: "es", label: "ES" },
  { code: "it", label: "IT" },
];

export const translations = {
  en: {
    "meta.title": "Javier Palina - Full Stack Developer",
    "meta.description":
      "Full Stack Developer based in Buenos Aires, Argentina focused on creating interactive digital experiences on the web.",

    "nav.folioHtml": "Full Stack Developer <br /> Portfolio",
    "nav.availabilityHtml":
      "Available for freelance <br /> work from October 2026",
    "nav.contact": "contact",
    "nav.langLabel": "Language",

    "hero.aboutHtml":
      '<span class="first-word">About</span> &nbsp; I am a developer based in Buenos Aires, Argentina focused on creating interactive digital experiences on the web, working with brands and industry leaders',
    "hero.scroll": "Scroll down",

    "projects.featuredHtml": "FEATURED <br /> PROJECTS (14)",
    "projects.visit": "Visit Site",

    "projects.ciclica.label": "ECOMMERCE / <br /> NEXTJS",
    "projects.ciclica.title": "Cíclica - Upcycled Textiles Ecommerce",
    "projects.totalGestion.label": "ERP / <br /> NEXTJS",
    "projects.totalGestion.title": "Total Gestión - Business Management Platform",
    "projects.enPuerta.label": "ACCESS CONTROL / <br /> WEBRTC",
    "projects.enPuerta.title": "En Puerta - Smart Virtual Doorman",
    "projects.vision.label": "ECOMMERCE / <br /> NEXTJS",
    "projects.vision.title": "Visión Ruidosa - Apparel Ecommerce",
    "projects.vannelli.label": "TRAVEL / <br /> TOUR OPERATOR",
    "projects.vannelli.title":
      "Vannelli Travel - Tour Operator Sicily & Sardinia",
    "projects.antigua.label": "ECOMMERCE / <br /> MERN STACK",
    "projects.antigua.title": "Antigua Escritura - Ecommerce",
    "projects.prakcintAr.label": "ECOMMERCE / <br /> MERN STACK",
    "projects.prakcintAr.title": "Prakcint Argentina - Ecommerce",
    "projects.prakcintIt.label": "ECOMMERCE / <br /> MERN STACK",
    "projects.prakcintIt.title": "Prakcint Italia - Ecommerce",
    "projects.jsbc.label": "ACCOUNTING / <br /> SERVICES",
    "projects.jsbc.title": "JSBC - Accounting Services",
    "projects.swift.label": "ITIN / <br /> SERVICES",
    "projects.swift.title": "Swift - ITIN Services",
    "projects.delme.label": "PORTFOLIO / <br /> MERN STACK",
    "projects.delme.title": "Valeria Delme - Portfolio",
    "projects.strixAr.label": "SECURITY / <br /> NEXTJS",
    "projects.strixAr.title": "Strix Argentina - Security Product",
    "projects.strixCl.label": "SECURITY / <br /> NEXTJS",
    "projects.strixCl.title": "Strix Chile - Security Product",
    "projects.strixUy.label": "SECURITY / <br /> NEXTJS",
    "projects.strixUy.title": "Strix Uruguay - Security Product",

    "community.title": "COMMUNITY CONTRIBUTIONS",
    "community.descHtml": `I have worked on some resources and tools; mostly for designers and developers like myself, you should checkout ${link(
      FIGMA_TINTS,
      "TINTS AND SHADES"
    )}, ${link(FIGMA_LOGOS, "NIGERIAN LOGOS")} and ${link(
      FIGMA_AVATARS,
      "BAVATARS."
    )}`,

    "stack.title": "STACK",

    "interests.title": "Interests",
    "interests.descHtml": `Art Direction, Brand Strategy, Creative Development, E-Commerce, Webflow, 3D/Augmented Reality, Web3, UX/UI <br /> ${link(
      GITHUB,
      "See my Github"
    )}`,

    "ice.title": "ICEBREAKERS",
    "ice.desc":
      "I like traveling and good food (work with me so I can fund this). Fan of Gustavo Cerati and coffee, probably taking some course right now, ask what it's about",

    "contact.desc":
      "Got a question, proposal or project or want to work together on something? Feel free to reach out.",
    "contact.marquee":
      "LET’S TALK — LET’S COLLABORATE — SAY HELLO — WANNA BE STARTING SOMETHING?",
    "contact.mailSubject": "Let's work together!",
    "contact.mailBody":
      "Hello, I think we need you to work on/collaborate this particular product... Reach out as soon as you can.",
    "contact.copy": "Click To Copy",
    "contact.copied": "copied",

    "footer.designBy": "Design by",
  },

  es: {
    "meta.title": "Javier Palina - Desarrollador Full Stack",
    "meta.description":
      "Desarrollador Full Stack radicado en Buenos Aires, Argentina, enfocado en crear experiencias digitales interactivas en la web.",

    "nav.folioHtml": "Portfolio <br /> Desarrollador Full Stack",
    "nav.availabilityHtml":
      "Disponible para proyectos <br /> freelance desde octubre 2026",
    "nav.contact": "contacto",
    "nav.langLabel": "Idioma",

    "hero.aboutHtml":
      '<span class="first-word">Sobre mí</span> &nbsp; Soy un desarrollador con base en Buenos Aires, Argentina, enfocado en crear experiencias digitales interactivas en la web, trabajando con marcas y líderes de la industria',
    "hero.scroll": "Deslizá hacia abajo",

    "projects.featuredHtml": "PROYECTOS <br /> DESTACADOS (14)",
    "projects.visit": "Ver sitio",

    "projects.ciclica.label": "ECOMMERCE / <br /> NEXTJS",
    "projects.ciclica.title": "Cíclica - Ecommerce de Textiles Recuperados",
    "projects.totalGestion.label": "ERP / <br /> NEXTJS",
    "projects.totalGestion.title": "Total Gestión - Sistema de Gestión para Pymes",
    "projects.enPuerta.label": "CONTROL DE ACCESOS / <br /> WEBRTC",
    "projects.enPuerta.title": "En Puerta - Portero Virtual Inteligente",
    "projects.vision.label": "ECOMMERCE / <br /> NEXTJS",
    "projects.vision.title": "Visión Ruidosa - Ecommerce de Indumentaria",
    "projects.vannelli.label": "VIAJES / <br /> OPERADOR TURÍSTICO",
    "projects.vannelli.title":
      "Vannelli Travel - Operador Turístico Sicilia y Cerdeña",
    "projects.antigua.label": "ECOMMERCE / <br /> MERN STACK",
    "projects.antigua.title": "Antigua Escritura - Ecommerce",
    "projects.prakcintAr.label": "ECOMMERCE / <br /> MERN STACK",
    "projects.prakcintAr.title": "Prakcint Argentina - Ecommerce",
    "projects.prakcintIt.label": "ECOMMERCE / <br /> MERN STACK",
    "projects.prakcintIt.title": "Prakcint Italia - Ecommerce",
    "projects.jsbc.label": "CONTABILIDAD / <br /> SERVICIOS",
    "projects.jsbc.title": "JSBC - Servicios Contables",
    "projects.swift.label": "ITIN / <br /> SERVICIOS",
    "projects.swift.title": "Swift - Servicios ITIN",
    "projects.delme.label": "PORTFOLIO / <br /> MERN STACK",
    "projects.delme.title": "Valeria Delme - Portfolio",
    "projects.strixAr.label": "SEGURIDAD / <br /> NEXTJS",
    "projects.strixAr.title": "Strix Argentina - Producto de Seguridad",
    "projects.strixCl.label": "SEGURIDAD / <br /> NEXTJS",
    "projects.strixCl.title": "Strix Chile - Producto de Seguridad",
    "projects.strixUy.label": "SEGURIDAD / <br /> NEXTJS",
    "projects.strixUy.title": "Strix Uruguay - Producto de Seguridad",

    "community.title": "CONTRIBUCIONES A LA COMUNIDAD",
    "community.descHtml": `Trabajé en algunos recursos y herramientas, en su mayoría para diseñadores y desarrolladores como yo. Te recomiendo ver ${link(
      FIGMA_TINTS,
      "TINTS AND SHADES"
    )}, ${link(FIGMA_LOGOS, "NIGERIAN LOGOS")} y ${link(
      FIGMA_AVATARS,
      "BAVATARS."
    )}`,

    "stack.title": "STACK",

    "interests.title": "Intereses",
    "interests.descHtml": `Dirección de Arte, Estrategia de Marca, Desarrollo Creativo, E-Commerce, Webflow, 3D/Realidad Aumentada, Web3, UX/UI <br /> ${link(
      GITHUB,
      "Ver mi Github"
    )}`,

    "ice.title": "ROMPAMOS EL HIELO",
    "ice.desc":
      "Viajar y comer bien son mi debilidad (contratame y ayudás a la causa). Fan de Cerati y el mate, y casi seguro estoy metido en algún curso nuevo: preguntame cuál.",

    "contact.desc":
      "¿Tenés un proyecto en mente o querés que trabajemos juntos? Escribime.",
    "contact.marquee":
      "HABLEMOS — COLABOREMOS — CONTAME TU IDEA — CREEMOS ALGO",
    "contact.mailSubject": "¡Trabajemos juntos!",
    "contact.mailBody":
      "Hola, creo que necesitamos que trabajes/colabores en este producto en particular... Escribime cuando puedas.",
    "contact.copy": "Clic para copiar",
    "contact.copied": "copiado",

    "footer.designBy": "Diseñado por",
  },

  it: {
    "meta.title": "Javier Palina - Sviluppatore Full Stack",
    "meta.description":
      "Sviluppatore Full Stack con base a Buenos Aires, Argentina, specializzato nella creazione di esperienze digitali interattive sul web.",

    "nav.folioHtml": "Sviluppatore Full Stack <br /> Portfolio",
    "nav.availabilityHtml":
      "Disponibile per progetti <br /> freelance da ottobre 2026",
    "nav.contact": "contatti",
    "nav.langLabel": "Lingua",

    "hero.aboutHtml":
      '<span class="first-word">Chi sono</span> &nbsp; Sono uno sviluppatore con base a Buenos Aires, Argentina, specializzato nella creazione di esperienze digitali interattive sul web, lavorando con brand e leader di settore',
    "hero.scroll": "Scorri in basso",

    "projects.featuredHtml": "PROGETTI <br /> IN EVIDENZA (14)",
    "projects.visit": "Visita il sito",

    "projects.ciclica.label": "ECOMMERCE / <br /> NEXTJS",
    "projects.ciclica.title": "Cíclica - Ecommerce di Tessuti Riciclati",
    "projects.totalGestion.label": "ERP / <br /> NEXTJS",
    "projects.totalGestion.title": "Total Gestión - Gestionale per PMI",
    "projects.enPuerta.label": "CONTROLLO ACCESSI / <br /> WEBRTC",
    "projects.enPuerta.title": "En Puerta - Portiere Virtuale Intelligente",
    "projects.vision.label": "ECOMMERCE / <br /> NEXTJS",
    "projects.vision.title": "Visión Ruidosa - Ecommerce di Abbigliamento",
    "projects.vannelli.label": "VIAGGI / <br /> TOUR OPERATOR",
    "projects.vannelli.title":
      "Vannelli Travel - Tour Operator Sicilia e Sardegna",
    "projects.antigua.label": "ECOMMERCE / <br /> MERN STACK",
    "projects.antigua.title": "Antigua Escritura - Ecommerce",
    "projects.prakcintAr.label": "ECOMMERCE / <br /> MERN STACK",
    "projects.prakcintAr.title": "Prakcint Argentina - Ecommerce",
    "projects.prakcintIt.label": "ECOMMERCE / <br /> MERN STACK",
    "projects.prakcintIt.title": "Prakcint Italia - Ecommerce",
    "projects.jsbc.label": "CONTABILITÀ / <br /> SERVIZI",
    "projects.jsbc.title": "JSBC - Servizi Contabili",
    "projects.swift.label": "ITIN / <br /> SERVIZI",
    "projects.swift.title": "Swift - Servizi ITIN",
    "projects.delme.label": "PORTFOLIO / <br /> MERN STACK",
    "projects.delme.title": "Valeria Delme - Portfolio",
    "projects.strixAr.label": "SICUREZZA / <br /> NEXTJS",
    "projects.strixAr.title": "Strix Argentina - Prodotto di Sicurezza",
    "projects.strixCl.label": "SICUREZZA / <br /> NEXTJS",
    "projects.strixCl.title": "Strix Chile - Prodotto di Sicurezza",
    "projects.strixUy.label": "SICUREZZA / <br /> NEXTJS",
    "projects.strixUy.title": "Strix Uruguay - Prodotto di Sicurezza",

    "community.title": "CONTRIBUTI ALLA COMUNITÀ",
    "community.descHtml": `Ho lavorato ad alcune risorse e strumenti, soprattutto per designer e sviluppatori come me. Dai un'occhiata a ${link(
      FIGMA_TINTS,
      "TINTS AND SHADES"
    )}, ${link(FIGMA_LOGOS, "NIGERIAN LOGOS")} e ${link(
      FIGMA_AVATARS,
      "BAVATARS."
    )}`,

    "stack.title": "STACK",

    "interests.title": "Interessi",
    "interests.descHtml": `Art Direction, Brand Strategy, Sviluppo Creativo, E-Commerce, Webflow, 3D/Realtà Aumentata, Web3, UX/UI <br /> ${link(
      GITHUB,
      "Vedi il mio Github"
    )}`,

    "ice.title": "ROMPIGHIACCIO",
    "ice.desc":
      "Mi piace viaggiare e il buon cibo (lavora con me così posso permettermelo). Fan di Gustavo Cerati e del caffè, probabilmente sto seguendo qualche corso proprio ora, chiedimi di cosa si tratta",

    "contact.desc":
      "Hai una domanda, una proposta o un progetto, oppure vuoi collaborare su qualcosa? Scrivimi pure.",
    "contact.marquee":
      "PARLIAMONE — COLLABORIAMO — DI’ CIAO — INIZIAMO QUALCOSA?",
    "contact.mailSubject": "Lavoriamo insieme!",
    "contact.mailBody":
      "Ciao, penso che avremmo bisogno di te per lavorare/collaborare su questo prodotto in particolare... Fammi sapere appena puoi.",
    "contact.copy": "Clicca per copiare",
    "contact.copied": "copiato",

    "footer.designBy": "Design di",
  },
};
